module.exports = __webpack_public_path__ + "img/john-doe.cde1c6fe.png";